// src/hooks/useCourses.js
import { useState, useEffect, useCallback } from "react";
import { useMsal } from "@azure/msal-react";
import { sharePointScopes } from "../authConfig";
import { fetchCourses } from "../services/sharePointService";

export function useCourses(filters) {
  const { instance, accounts } = useMsal();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!accounts.length) return;
    setLoading(true);
    setError(null);
    try {
      // Silent token acquisition; falls back to redirect if needed
      const tokenResponse = await instance.acquireTokenSilent({
        ...sharePointScopes,
        account: accounts[0],
      });
      const data = await fetchCourses(tokenResponse.accessToken, filters);
      setCourses(data);
    } catch (err) {
      console.error("Failed to load courses:", err);
      if (err.name === "InteractionRequiredAuthError") {
        // Token expired or consent needed — trigger interactive login
        await instance.acquireTokenRedirect(sharePointScopes);
      } else {
        setError(err.message || "Failed to load data from SharePoint.");
      }
    } finally {
      setLoading(false);
    }
  }, [instance, accounts, filters]);

  useEffect(() => {
    load();
  }, [load]);

  return { courses, loading, error, reload: load };
}
